<rt-dialog-header
  [heading]="'app.requisitions.assign_hires_dialog.heading' | translate"
  [stepText]="stepText"
>
  {{ 'app.requisitions.assign_hires_dialog.subheading' | translate }}&nbsp;
</rt-dialog-header>

<rt-dialog-body layout-vertical>
  @if (notEnoughOpenings) {
    <rt-infobox
      [heading]="
        'app.requisitions.assign_hires_dialog.not_enough_openings_infobox.heading'
          | translate: { count: openings.length }
      "
      [isDismissible]="false"
      type="transparent"
      iconName="info-outline"
      margin-bottom-small
    >
      <span
        [innerHTML]="
          'app.requisitions.assign_hires_dialog.not_enough_openings_infobox.message'
            | translate: { count: openings.length }
        "
      ></span>
    </rt-infobox>
  }
  <div class="grid-row">
    <rt-heading variant="heading">
      {{ 'app.requisitions.assign_hires_dialog.candidate_label' | translate }}
    </rt-heading>
    <div></div>
    <rt-heading variant="heading">
      {{ 'app.requisitions.assign_hires_dialog.opening_label' | translate }}
    </rt-heading>
  </div>
  @for (placement of placements; track trackById($index, placement)) {
    <div class="grid-row" margin-top-small>
      <div layout-horizontal layout-align-items-center>
        <rt-avatar
          [type]="placement.candidate.hasAvatar ? 'image' : 'initials'"
          [initials]="placement.candidate.initials"
          [imageSrc]="placement.candidate.photoThumbUrl"
        ></rt-avatar>
        <rt-truncate class="candidate-name" margin-left-small>
          {{ placement.candidate.name }}
        </rt-truncate>
      </div>

      <div><rt-icon name="keyboard-backspace" margin-lr-medium></rt-icon></div>

      @if (optionsMap.get(placement.id); as options) {
        <rt-select
          [triggerTemplate]="selectTrigger"
          [disabled]="autoAssign || !options.length"
          [options]="options"
          [formControl]="getOpeningControl(placement.id)"
          [hasInputTrigger]="true"
          [hasSearch]="options.length > 5"
          [placeholder]="availableOpenings.length ? texts.selectOpening : texts.notAssigned"
        ></rt-select>
      }
    </div>

    <ng-template
      #selectTrigger
      let-selectedOption="selectedOption"
      let-dropdownOpened="dropdownOpened"
      let-toggleDropdown="toggleDropdown"
      let-disabled="disabled"
      let-placeholder="placeholder"
    >
      <rt-input
        #input
        [disabled]="disabled"
        [readOnly]="true"
        [placeholder]="placeholder"
        [hasDropdownIndicator]="!selectedOption?.value && !disabled"
        [class.dropdownOpened]="dropdownOpened"
        [value]="selectedOption?.value && selectedOption?.label ? selectedOption.label : ''"
        [invalid]="false"
        [hasClearButton]="!!selectedOption?.value && !disabled"
        (reset)="
          input.setBlur();
          $event.stopPropagation();
          getOpeningControl(placement.id)?.patchValue(null)
        "
        (click)="!disabled && !dropdownOpened && toggleDropdown(true)"
        variant="rounded"
      >
      </rt-input>
    </ng-template>
  }
</rt-dialog-body>

<rt-dialog-footer [hasOptionalActions]="true">
  <rt-button class="optional" (click)="goBack()" variant="plain">
    <rt-icon name="arrow-back"></rt-icon>
    {{ 'app.common.go_back' | translate }}
  </rt-button>
  <rt-button (click)="cancel()" variant="plain">
    {{ 'app.common.cancel' | translate }}
  </rt-button>
  <rt-button [disabled]="form.invalid" (click)="save()" variant="primary">
    {{ 'app.requisitions.assign_hires_dialog.agree_label' | translate }}
  </rt-button>
</rt-dialog-footer>
